import React, { useState } from 'react';
import { Card, Flex, Skeleton } from 'antd';
import { useGetTrip } from 'api/trips/use-get-trip.ts';
import { useRoleGuard } from 'shared/hooks/use-role-guard';
import { UserRole } from 'types/user';
import { DocumentsList } from 'components/documents/documents-list';
import { DocumentsUpload } from 'components/documents/documents-upload';
import { ExpensesListWithCreateButton } from 'components/expenses/expenses-list-with-create-button';
import { AddFavoriteButton } from 'components/favorites/add-favorite-button/add-favorite-button.tsx';
import { TripAdditionalCosts } from 'components/trips/trip-additional-costs';
import { TripTaskActions } from 'components/trips/trip-task-actions';
import { TripCargoList } from '../trip-cargo-list/trip-cargo-list.tsx';
import { ETripMainTab } from './types.ts';
import type { ITripMainProps } from './types.ts';

export const TripMain: React.FC<ITripMainProps> = (props) => {
  const { tripId } = props;

  const { data: trip, isLoading } = useGetTrip(tripId);
  const [activeTabKey, setActiveTabKey] = useState<ETripMainTab>(ETripMainTab.cargos);
  const isExpensesTabVisible = useRoleGuard([UserRole.admin, UserRole.assistant, UserRole.accountant]);

  const onTabChange = (key: string) => {
    setActiveTabKey(key as ETripMainTab);
  };

  const tabListNoTitle = [
    {
      key: ETripMainTab.cargos,
      label: 'Cargos',
    },
    {
      key: ETripMainTab.documents,
      label: 'Documents',
    },
    {
      key: ETripMainTab.additionalCosts,
      label: 'Additional Costs',
    },
    ...(isExpensesTabVisible
      ? [
          {
            key: ETripMainTab.expenses,
            label: 'Expenses',
          },
        ]
      : []),
  ];

  if (isLoading || !trip) return <Skeleton loading />;

  const contentListNoTitle: Record<ETripMainTab, React.ReactNode> = {
    [ETripMainTab.cargos]: (
      <>
        <Flex gap='middle' vertical>
          <Flex gap='middle' align='center' justify='flex-end'>
            <AddFavoriteButton tripId={trip.id} />
            <TripTaskActions tripId={trip.id} tripStatus={trip.status} />
          </Flex>
          <TripCargoList trip={trip} />
        </Flex>
      </>
    ),
    [ETripMainTab.documents]: (
      <>
        <DocumentsUpload tripId={trip.id} />
        <DocumentsList tripId={trip.id} />
      </>
    ),
    [ETripMainTab.additionalCosts]: <TripAdditionalCosts tripId={trip.id} />,
    [ETripMainTab.expenses]: isExpensesTabVisible ? <ExpensesListWithCreateButton tripId={trip.id} /> : null,
  };

  return (
    <Card style={{ width: '100%' }} tabList={tabListNoTitle} activeTabKey={activeTabKey} onTabChange={onTabChange}>
      {contentListNoTitle[activeTabKey]}
    </Card>
  );
};
